const getTimeNow = (): number => {
  return new Date().getTime()
}

const getPastTime = (time: number): number => {
  return getTimeNow() - time
}

export {getTimeNow, getPastTime}
